let account = {
  loginNet: {
    //登录接口
    url: '/scooper-core-rest/data/system/authManage/loginTo',
    requestParam: {
      accUsername: '',
      accPassword: ''
    },
    responseParam: {
      code: '',
      //返回结果状态码
      message: '',
      systemTime: '',
      //yyyy-MM-dd HH:mm:ss
      data: '' //token

    }
  },
  heartBeatNet: {
    //账号心跳保持接口， 长轮询调用该接口保持与服务端的连接，每15s发送一次该消息，如果60s内没有收到该消息，服务端主动注销该用户
    // url: '/scooper-core-rest/data/system/authManage/heartbeat',
    url: '/dispatch-web/api/conn/heartKeep',
    requestParam: {
      token: ''
    },
    responseParam: {
      code: '',
      //返回结果状态码
      message: '',
      systemTime: '',
      //yyyy-MM-dd HH:mm:ss
      data: ''
    }
  },
  logoutNet: {
    //登出接口
    url: '/scooper-core-rest/data/system/authManage/logout',
    requestParam: {
      token: ''
    },
    responseParam: {
      code: '',
      //返回结果状态码
      message: '',
      systemTime: '',
      //yyyy-MM-dd HH:mm:ss
      data: ''
    }
  },
  accountMqttNet: {
    //MQTT订阅方式获取账号连接状态改变通知 cometd
    topic: '/notify/auth/connect',
    responseParam: {
      id: '',
      //0 数据id
      type: '',
      //connectStatus  
      source: '',
      //scooper-core
      data: {
        user: '',
        token: '',
        status: '' //0:退出登录 1：登录成功

      } //通知消息体

    }
  },
  accountHttpNet: {
    //账号连接状态改变HTTP推送通知
    url: '/notify/auth/connect',
    method: 'POST',
    requestParam: {
      user: '',
      type: 'connectStatus',
      status: '' //0: 退出登录  1：登录成功

    },
    responseParam: {
      code: ''
    }
  },
  saveAccountNet: {
    //新增帐号

    /**
     * 新增账号，该接口只支持简单的账号信息填写和关联一个部门成员，如有其它业务需要，可以通过我司的通讯录配置网页进行编辑添加
     */
    url: '/scooper-core-rest/data/system/accountManage/saveAccount',
    method: 'POST',
    requestParam: {
      token: '',
      accUsername: '',
      accPassword: '',
      accShowname: '',
      //帐号显示名称
      accType: '',
      //帐号类型，该字段已弃用     0-管理员;  1-一般用户;  2-调度操作员
      memId: '',
      //通讯录成员ID   (帐号关联成员)
      relDispUsername: '',
      useSbc: '',
      //是否启用边界网关0-否|1-是
      businessConfigs: '',
      //业务权限，eg: sip,JK,dispatch,whiteboard,appMsg,video$!$  分隔符'$!$'后面的全部是账号拥有的权限
      sipTel: '',
      dispatchAccount: '',
      roleIds: 1,
      isOperAcc: false,
      centerId: 0,
      operLevel: 0,
      operType: 0,
      operatorId: 0,
      mainTel: '',
      viceTel: '',
      corpId: '',
      pocTel: '',
      operMobileTel: ''
    },
    responseParam: {
      code: '',
      //返回结果状态码
      message: '',
      systemTime: '',
      //yyyy-MM-dd HH:mm:ss
      data: '' //返回插入成功的ID

    }
  },
  updateAccountNet: {
    //更新帐号

    /**
     * 根据token和id更新帐号信息
     */
    url: '/scooper-core-rest/data/system/accountManage/updateAccount',
    method: 'POST',
    requestParam: {
      id: '',
      token: '',
      accUsername: '',
      accPassword: '',
      accShowname: '',
      //帐号显示名称
      accType: '',
      //帐号类型，该字段已弃用     0-管理员;  1-一般用户;  2-调度操作员
      memId: '' //通讯录成员ID   (帐号关联成员)

    },
    responseParam: {
      code: '',
      //返回结果状态码
      message: '',
      systemTime: '',
      //yyyy-MM-dd HH:mm:ss
      data: ''
    }
  },
  deleteAccountNet: {
    //删除帐号
    url: '/scooper-core-rest/data/system/accountManage/deleteAccount',
    method: 'POST',
    requestParam: {
      ids: '',
      //编号 多个以","分割
      token: ''
    },
    responseParam: {
      code: '',
      //返回结果状态码
      message: '',
      systemTime: '',
      //yyyy-MM-dd HH:mm:ss
      data: {}
    }
  },
  resetPwdNet: {
    //密码重置
    url: '/scooper-core-rest/data/system/accountManage/resetPwd',
    method: 'POST',
    requestParam: {
      id: '',
      //帐号标识   id / accUserName 必须选择一个参数
      token: '',
      accUsername: '',
      //用户名
      origPwd: '',
      //原密码，传递了原密码会对原密码校验，不通过则无法重置密码
      newPwd: '' //新密码

    },
    responseParam: {
      code: '',
      //返回结果状态码
      message: '',
      systemTime: '',
      //yyyy-MM-dd HH:mm:ss
      data: {}
    }
  },
  resetSelfPwdNet: {
    //账号自身密码重置

    /**
     * 根据账号token，更改自身密码
     */
    url: '/data/system/accountManage/resetSelfPwd',
    method: 'POST',
    requestParam: {
      token: '',
      origPwd: '',
      //原密码，传递了原密码会对原密码校验，不通过则无法重置密码
      newPwd: '' //新密码

    },
    responseParam: {
      code: '',
      //返回结果状态码
      message: '',
      systemTime: '',
      //yyyy-MM-dd HH:mm:ss
      data: {}
    }
  },
  listAccountNet: {
    //查询帐号列表
    url: '/scooper-core-rest/data/system/accountManage/listAccount',
    requestParam: {
      id: '',
      token: '',
      accUsername: '',
      accShowname: '',
      //帐号显示名称
      accType: '',
      //帐号类型，该字段已弃用    0-管理员;  1-一般用户;  2-调度操作员
      validToken: '',
      //有效token
      invalidTimeStart: '' //登录失效开始日期

    },
    responseParam: {
      code: '',
      //返回结果状态码
      message: '',
      systemTime: '',
      //yyyy-MM-dd HH:mm:ss
      data: [{
        id: '',
        //帐号标识
        groupId: '',
        //账号组
        accUsername: '',
        accPassword: '',
        accShowname: '',
        //帐号显示名称
        accType: '',
        //帐号类型 0-管理员；1-一般用户；2-调度操作员
        scopeDept: '',
        //管辖的部门,保留字段
        scopeVideo: '',
        //管辖的视频,保留字段
        validToken: '',
        //有效token
        isActive: '',
        //是否激活
        modifyTime: '',
        createTime: '',
        useSbc: '',
        //是否启用边界网关0-否|1-是
        single: '',
        //更新时是否只更新账号信息
        jkSbc: '' //捷控关联的帐号（sip帐号）

      }]
    }
  },
  queryAccountNet: {
    //分页查询帐号列表
    url: '/scooper-core-rest/data/system/accountManage/queryAccount',
    requestParam: {
      currentPage: '',
      token: '',
      pageSize: '',
      id: '',
      accUsername: '',
      accShowname: '',
      //帐号显示名称
      accType: '',
      //帐号类型，该字段已弃用    0-管理员;  1-一般用户;  2-调度操作员
      validToken: '',
      //有效token
      invalidTimeStart: '' //登录失效开始日期

    },
    responseParam: {
      code: '',
      //返回结果状态码
      message: '',
      systemTime: '',
      //yyyy-MM-dd HH:mm:ss
      data: {
        pageNum: '',
        pageSize: '',
        //每页的数量
        size: '',
        //当前页的数量
        startRow: '',
        //当前页面第一个元素在数据库中的行号
        endRow: '',
        //当前页面最后一个元素在数据库中的行号
        total: '',
        pages: '',
        modifyPwTime: '',
        firstPage: '',
        perPage: '',
        nextPage: '',
        lastPage: '',
        isFirstPage: '',
        isLastPage: '',
        hasPreviousPage: '',
        hasNextPage: '',
        navigatePage: '',
        //导航页码数
        navigatePageNums: '',
        //所有导航页号
        list: [{
          id: '',
          //帐号标识
          groupId: '',
          //账号组
          accUsername: '',
          accPassword: '',
          accShowname: '',
          //帐号显示名称
          accType: '',
          //帐号类型 0-管理员；1-一般用户；2-调度操作员
          scopeDept: '',
          //管辖的部门,保留字段
          scopeVideo: '',
          //管辖的视频,保留字段
          validToken: '',
          //有效token
          isActive: '',
          //是否激活
          modifyTime: '',
          createTime: '',
          useSbc: '',
          //是否启用边界网关0-否|1-是
          single: '',
          //更新时是否只更新账号信息
          jkSbc: '' //捷控关联的帐号（sip帐号）

        }]
      }
    }
  },
  getAccountLinkMemberNet: {
    //查询帐号关联部门成员信息

    /**
     * 根据id，validToken，accUsername获取账号关联部门成员信息
     */
    url: '/scooper-core-rest/data/system/accountManage/getAccountLinkMember',
    requestParam: {
      token: '',
      accUsername: '',
      id: '',
      validToken: ''
    },
    responseParam: {
      code: '',
      //返回结果状态码
      message: '',
      systemTime: '',
      //yyyy-MM-dd HH:mm:ss
      data: {
        id: '',
        //帐号标识
        groupId: '',
        //账号组
        accUsername: '',
        accPassword: '',
        accShowname: '',
        //帐号显示名称
        accType: '',
        //帐号类型 0-管理员；1-一般用户；2-调度操作员
        scopeDept: '',
        //管辖的部门,保留字段
        scopeVideo: '',
        //管辖的视频,保留字段
        validToken: '',
        //有效token
        isActive: '',
        //是否激活
        modifyTime: '',
        createTime: '',
        useSbc: '',
        //是否启用边界网关0-否|1-是
        single: '',
        //更新时是否只更新账号信息
        jkSbc: '',
        //捷控关联的帐号（sip帐号）
        memId: '',
        //	成员ID
        memName: '',
        //	成员姓名
        deptId: '',
        //	部门编号
        deptName: '',
        //	部门名称
        orgCode: '',
        //	组织编码
        sex: '',
        //	性别
        memTel: '',
        //	成员号码
        memMobile: '' //	成员手机号

      }
    }
  },
  updateDeptDataPermission: {
    //更新账号通讯录权限
    url: '/scooper-core-rest/data/system/permisions/pmDataRPermManage/updatePmDataRPerm',
    requestParam: {
      accId: '',
      deptOrgCodes: '' //a:*代表完整的通讯录

    },
    responseParam: {
      code: '',
      //返回结果状态码
      message: '',
      systemTime: '',
      //yyyy-MM-dd HH:mm:ss
      data: {
        obj: 0
      }
    }
  },
  getAccountDetailNet: {
    //查询帐号详情

    /**
     * 根据id，validToken，accUsername获取账号信息
     */
    url: '/scooper-core-rest/data/system/accountManage/getAccountDetail',
    requestParam: {
      token: '',
      accUsername: '',
      id: '',
      validToken: ''
    },
    responseParam: {
      code: '',
      //返回结果状态码
      message: '',
      systemTime: '',
      //yyyy-MM-dd HH:mm:ss
      data: {
        id: '',
        //帐号标识
        groupId: '',
        //账号组
        accUsername: '',
        accPassword: '',
        accShowname: '',
        //帐号显示名称
        accType: '',
        //帐号类型 0-管理员；1-一般用户；2-调度操作员
        scopeDept: '',
        //管辖的部门,保留字段
        scopeVideo: '',
        //管辖的视频,保留字段
        validToken: '',
        //有效token
        isActive: '',
        //是否激活
        modifyTime: '',
        createTime: '',
        invalidTime: '',
        //失效时间
        accessTime: '',
        //登录系统时间
        useSbc: '',
        //是否启用边界网关0-否|1-是
        modifyPwdTime: '',
        //
        realDispUsername: '',
        //真实的调度帐号名
        businessConfigList: {
          //业务配置信息
          id: '',
          //业务配置信息标识
          accId: '',
          //	帐号标识
          type: '',
          //	帐号类型
          actived: '',
          //	是否启用
          lastOnline: '',
          //最后在线时间（应用按固定频率更新该值）
          modifyTime: '',
          //	最后修改时间
          ext: '' //应用附加数据(保留)

        },
        single: '',
        //更新时是否只更新账号信息
        jkSbc: '',
        //捷控关联帐号的sbc是否使用边界网关 0-否； 1-是
        PmDataList: {
          //数据权限列表
          accId: '',
          //	帐号id
          deptOrgCode: '',
          //	部门的orgCode
          isActive: '',
          //	是否激活
          deptName: '' //	部门名称

        }
      }
    }
  },

  /**
   * MQTT订阅
   */
  accountAddMQNet: function () {
    //新增帐号通知
    return {
      topic: '/scooper_core/dataChange/account',
      responseParam: {
        id: '',
        type: 'add',
        //消息类别
        source: 'scooper-core-ds',
        //消息来源
        data: {//通知的具体消息
        }
      }
    };
  },
  accountUpdateMQNet: function () {
    //更新帐号通知
    return {
      topic: '/scooper_core/dataChange/account',
      responseParam: {
        id: '',
        type: 'update',
        //消息类别
        source: 'scooper-core-ds',
        //消息来源
        data: {//通知的具体消息
        }
      }
    };
  },
  accountDeleteMQNet: function () {
    //删除帐号通知
    return {
      topic: '/scooper_core/dataChange/account',
      responseParam: {
        id: '',
        type: 'delete',
        //消息类别
        source: 'scooper-core-ds',
        //消息来源
        data: {//通知的具体消息
        }
      }
    };
  },

  /**
   * HTTP推送
   */
  accountAddHttpNet: function () {
    return {
      //新增帐号通知HTTP推送通知
      url: '/data/dataChange/account/add',
      method: 'POST',
      requestParam: {
        id: '' //新增账号ID

      },
      responseParam: {
        code: '' //返回结果状态码

      }
    };
  },
  accountUpdateHttpNet: function () {
    /**
     * 根据token和id更新帐号信息
     */
    return {
      //更新帐号通知HTTP推送通知
      url: '/data/dataChange/account/update',
      method: 'POST',
      requestParam: {
        id: '' //更新账号ID

      },
      responseParam: {
        code: '' //返回结果状态码

      }
    };
  },
  accountDeleteHttpNet: function () {
    return {
      //删除帐号通知HTTP推送通知
      url: '/data/dataChange/account/delete',
      method: 'POST',
      requestParam: {
        ids: '' //编号 多个以","分割

      },
      responseParam: {
        code: '' //返回结果状态码

      }
    };
  }
};
export default account;